import React from "react";
import ReportTemplate2 from "../reportTemplate2";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import { Tooltip } from "antd";

function MaterialFlowByContractorReport() {
  const navigate = useNavigate();
  const columns: any = [
    {
      title: "Contractor",
      dataIndex: "contractorName",
      key: "contractorName",
      width: 200,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 250,
    },
    {
      title: "Category",
      key: "category",
      dataIndex: "category",
      width: 200,
    },
    {
      title: "Material",
      key: "material",
      dataIndex: "material",
      width: 200,
    },
    {
      title: "UOM",
      key: "uom",
      dataIndex: "uom",
      width: 100,
    },
    {
      title: "Inward Qty",
      key: "inwardQty",
      dataIndex: "inwardQty",
      width: 150,
      render: (text: any) => parseFloat(text || 0).toFixed(3),
    },
    {
      title: "Outward Qty",
      key: "outwardQty",
      dataIndex: "outwardQty",
      width: 150,
      render: (text: any) => parseFloat(text || 0).toFixed(3),
    },
    {
      title: "Issued Qty",
      key: "issuedQty",
      dataIndex: "issuedQty",
      width: 150,
      render: (text: any) => parseFloat(text || 0).toFixed(3),
    },
    {
      title: "Damaged Qty",
      key: "damagedQty",
      dataIndex: "damagedQty",
      width: 150,
      render: (text: any) => parseFloat(text || 0).toFixed(3),
    },
    {
      title: "Returned Qty",
      key: "returnedQty",
      dataIndex: "returnedQty",
      width: 150,
      render: (text: any) => parseFloat(text || 0).toFixed(3),
    },
    {
      title: (
        <Tooltip title="Inward Qty - Outward Qty - Issued Qty - Damaged Qty + Returned Qty">
          Balance Qty
        </Tooltip>
      ),
      key: "balanceQty",
      dataIndex: "balanceQty",
      width: 150,
      render: (text: any, record: any) => {
        const balance = parseFloat(text || 0);
        return (
          <span
            className={balance >= 0 ? "inlineTableCellLink" : ""}
            style={{ color: balance < 0 ? "red" : "green", fontWeight: "bold" }}
            onClick={() => {
              if (balance >= 0) {
                navigate(`/material-balance-breakdown/${record.materialId}`, {
                  state: {
                    contractor: record.contractorName,
                    contractorId: record.contractorId,
                    material: record.material,
                    materialId: record.materialId,
                    category: record.category,
                    categoryId: record.categoryId,
                    site: record.siteName,
                    siteId: record.siteId,
                    balanceQty: balance,
                    breakdown: {
                      qtyReceived: parseFloat(record.inwardQty || 0),
                      qtyIssued: parseFloat(record.outwardQty || 0),
                      qtyUtilized: parseFloat(record.issuedQty || 0),
                      qtyDamaged: parseFloat(record.damagedQty || 0),
                      qtyReturned: parseFloat(record.returnedQty || 0),
                    },
                  },
                });
              }
            }}
          >
            {balance.toFixed(3)}
          </span>
        );
      },
    },
  ];

  return (
    <ReportTemplate2
      pageTitle="Material Flow Summary by Contractor"
      pageDescription="Comprehensive overview of material flow categorized by contractor for tracking and analysis"
      moduleKey="MaterialFlowByContractorReport"
      columns={columns}
      extra={{
        tableScrollX: 2000,
      }}
      filtersOption={{
        contractor: true,
        site: true,
        category: true,
        date: true,
        dateRange: false,
      }}
      previousPath="/view-inventory-reports"
    />
  );
}

export default MaterialFlowByContractorReport;
